import type { GetNotificationCount } from "../types/adapters";
import type { CommunitySwitcher } from "../types/CommunitySwitcher";

export const getCommunitySwitcherIconUrl = (
  community: CommunitySwitcher,
  isDarkAppearance: boolean,
): string => {
  const darkUrl = community.dark_icon_url || community.light_icon_url;
  const lightUrl = community.light_icon_url || "";
  return isDarkAppearance ? darkUrl || "" : lightUrl || "";
};

export const getCommunitySwitcherNotificationCount = (
  community: CommunitySwitcher,
  getNotificationCount: GetNotificationCount,
  mode: "sidebar" | "list",
): number => {
  if (mode === "list") {
    return getNotificationCount(community);
  }
  return community.is_current_community ? 0 : getNotificationCount(community);
};
